module.exports = __webpack_public_path__ + "img/mph.71095efe.jpg";